import { heroEquipment } from "../HeroEquipment";

export const krasnoludyChaosu = {
  heroes: {
    Czarnoksiężnik: {
      id: 0,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 75,
      number: 1,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Czarnoksiężnik,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 3, 4, 4, 2, 3, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: ["Czarnoksięstwo","Dowodzenie","Dowódca","Krzepki","Mag (Dziedzina Hashuta)","Nieustępliwy","Odporność na magię (2)","Palankin","Przekleństwo kamienia","Rewelator","Trudny do zabicia","Uporczywość","Wspinaczka","Zasadzka","Zawiść"],
      exp: 20,
      skills: [0, 2, 3, 5],
    },
    "Mistrz inżynier": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Drużyna obsługi",
        "Inżynier",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Saper",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zasadzka",
        "Zawiść",
        "Żniwiarz",
      ],
      exp: 12,
      skills: [0, 1, 2, 3, 5],
    },
    "Łowca niewolników": {
      id: 2,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 40,
      number: 1,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Handlarz niewolników",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zawiść",
        "Żertwa",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    Bykocentaur: {
      id: 3,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 80,
      number: 1,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Bohaterowie,
      type: "Bohater",

      stats: {
        Początkowa: [6, 4, 3, 4, 4, 1, 2, 1, 8],
        Maksymalna: [7, 7, 6, 4, 5, 4, 6, 4, 9],
      },
      rules: [
        "Bycza szarża",
        "Centaur",
        "Głód krwi",
        "Krzepki",
        "Łuskowata skóra (5+)",
        "Uporczywość",
        "Zawiść",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Hobgoblin: {
      id: 5,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 20,
      number: 15,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Hobgoblin,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 4, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 7],
      },
      rules: [
        "Animozja",
        "Drużyna obsługi",
        "Rozmiar rzondzi",
        "Stan niższy",
        "Zasadzka",
      ],
    },
    "Wojownik klanowy": {
      id: 6,
      startingEquipment: ["Sztylet"],
      cost: 25,
      number: 5,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Palankin",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zawiść",
      ],
    },
    "Wilczy jeździec": {
      id: 7,
      startingEquipment: [
        "Sztylet",
        "Włócznia",
        "Tarcza",
        "Wielki wilk",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList:
        heroEquipment["Krasnoludowie Chaosu z Zorn Uzkul"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 4, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 7],
        "Wielki wilk": [9, 3, 0, 4, "-", "-", 3, 1, 3],
      },
      rules: [
        "Animozja",
        "Kawalerzysta",
        "Lekka jazda",
        "Stan niższy",
        "Zasadzka",
      ],
    },
    Zagan: {
      id: 8,
      startingEquipment: ["Broń naturalna (płonący atak)"],
      cost: 250,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 5, 4, 3, 4, 3, 6],
        Maksymalna: [6, 4, 0, 5, 4, 3, 4, 3, 6],
      },
      rules: ["Głód krwi","Furia","Krzepki","Lot","Łuskowata skóra (5+)","Ognista korona","Potwór","Uporczywość","Wierzchowiec","Zwierzę"],
    },
    "Żelazny Demon": {
      id: 9,
      startingEquipment: [],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["*", "-", "-", 5, 8, 8, "-", "*", "-"],
        Maksymalna: ["*", "-", "-", 5, 8, 8, "-", "*", "-"],
      },
      rules: [
        "Demon",
        "Duży cel",
        "Granatnik",
        "Machina wojenna",
        "Pancerny",
        "Parowóz",
        "Rydwan",
        "Więźniarka",
        "Żelazny Demon",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Krasnoludowie Chaosu z Zorn Uzkul",
  nature: "Zła",
  armyRules: ["Palankin", "Podatek", "Reduta", "Rozrzutność"],
  mercenaries: [
    "Czarownica",
    "Hiena cmentarna",
    "Łowca nagród",
    "Kanonier",
    "Porywacz zwłok",
    "Rozbójnik",
    "Skryba",
    "Szczelec",
    "Szpieg",
    "Złodziej",
  ],
};
